module.exports = __webpack_public_path__ + "img/house_08.8a74bf9e.jpg";